import { MultipleInvoiceList } from "../components/MultipleInvoiceList";

export const List = () => <MultipleInvoiceList mode="substitute" />;
